import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/monitoring/blood-pressure-pregnancy/#webpage",
   "url": "https://www.futurefamilyai.com/monitoring/blood-pressure-pregnancy/",
   "name": "Blood Pressure Monitoring During Pregnancy | FutureFamilyAI",
   "description": "How and when to check blood pressure in pregnancy, what readings mean, and how FutureFamilyAI organizes cuff readings for your care team.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Blood Pressure During Pregnancy",
     "item": "https://www.futurefamilyai.com/monitoring/blood-pressure-pregnancy/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What is a normal blood pressure during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Many clinicians consider readings below 140/90 mm Hg within the expected range, but what is right for you depends on your history. Ask your clinician for your personal targets and when to call."
     }
    },
    {
     "@type": "Question",
     "name": "What blood pressure is too high when pregnant?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Readings of 140/90 or higher are generally considered elevated in pregnancy, and 160/110 or higher is in the severe range needing urgent evaluation. Follow your clinician's written plan."
     }
    },
    {
     "@type": "Question",
     "name": "How often should I check my blood pressure while pregnant?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Your clinician sets the schedule. Common plans are once or twice daily for people at higher risk. Consistency matters more than frequency."
     }
    },
    {
     "@type": "Question",
     "name": "Can I check my blood pressure with my Apple Watch or Galaxy Watch?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Not for FutureFamilyAI. Apple Watch does not measure blood pressure and Apple's hypertension notifications are not intended for pregnancy; Samsung's watch feature gives cuff-calibrated estimates that FutureFamilyAI does not use. A validated upper-arm cuff is the only blood pressure source."
     }
    },
    {
     "@type": "Question",
     "name": "What time of day is best to take blood pressure when pregnant?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Choose consistent times, often morning and evening, before caffeine or exercise. Rest for five minutes first and record any symptoms."
     }
    },
    {
     "@type": "Question",
     "name": "Does high blood pressure in pregnancy go away after birth?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Often it improves, but it can persist or even appear after delivery. Keep monitoring postpartum as your clinician advises."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function MonitoringBloodPressurePregnancyPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Blood Pressure During Pregnancy</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Blood pressure monitoring during pregnancy means measuring with
                a validated upper-arm cuff on a schedule your clinician sets and
                acting on readings above your agreed thresholds.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Hypertensive disorders were present in about 1 in 7 U.S.
                      delivery hospitalizations (2017–2019). (CDC, MMWR 2022)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Cuff readings are the only BP source — no watch guesses ·
                      Thresholds come from your clinician&apos;s plan · Symptoms
                      logged alongside every reading
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PILLAR GUIDE · BLOOD PRESSURE</span>
            <h1>
              Blood Pressure Monitoring During Pregnancy: A Complete Guide
            </h1>
            <p className="ffh-answer speakable-content">
              Blood pressure monitoring during pregnancy means measuring with a
              validated upper-arm cuff on a schedule your clinician sets and
              acting on readings above your agreed thresholds. Hypertensive
              disorders affected about 1 in 7 U.S. delivery hospitalizations
              (CDC, 2022). FutureFamilyAI organizes your cuff readings and
              symptoms into a color status reviewed by a care team. Start
              monitoring with the free pilot.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Validated upper-arm cuff used for home blood pressure monitoring during pregnancy"
              >
                <figcaption>
                  <b>Photo slot</b> · Close-up photo of a woman&apos;s upper arm
                  in a white validated cuff, phone on the table beside her, soft
                  focus background. Her pregnant belly partly visible. No digits
                  legible on any screen.
                  <br />
                  <b>Alt:</b> Validated upper-arm cuff used for home blood
                  pressure monitoring during pregnancy
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                  <li>
                    In pregnancy, a blood pressure of 160 systolic or 110
                    diastolic or higher is in the severe range and needs urgent
                    evaluation.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/practice-bulletin/articles/2020/06/gestational-hypertension-and-preeclampsia">
                        ACOG Practice Bulletin No. 222, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    Validated upper-arm devices are recommended for
                    self-measured blood pressure; wrist and finger devices are
                    not recommended for routine use.
                    <cite>
                      Source:{" "}
                      <a href="https://www.ahajournals.org/doi/10.1161/CIR.0000000000000803">
                        AHA/AMA Joint Policy Statement, 2020
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Why blood pressure matters so much in pregnancy</h2>
                <p>
                  Gestational hypertension and preeclampsia can develop without
                  obvious symptoms, usually after 20 weeks. Regular measurement
                  is how they are noticed. Home readings between visits give
                  your clinician far more data points than clinic visits alone.
                </p>
              </section>
              <section id="s2">
                <h2>How to take an accurate reading at home</h2>
                <ul>
                  <li>Use a validated upper-arm cuff in the correct size.</li>
                  <li>
                    Sit quietly for five minutes, back supported, feet flat, arm
                    at heart level.
                  </li>
                  <li>
                    Take two readings a minute apart at consistent times of day.
                  </li>
                  <li>
                    Log symptoms at the same time — headache, vision changes,
                    swelling or pain.
                  </li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="s3">
                <h2>What your readings mean — and who decides</h2>
                <p>
                  Ask your clinician for written thresholds and a plan for
                  elevated readings. ACOG classifies 160 systolic or 110
                  diastolic or higher as the severe range, which needs urgent
                  evaluation. FutureFamilyAI never replaces that plan; it helps
                  you follow it.
                </p>
              </section>
              <section id="s4">
                <h2>How FutureFamilyAI helps</h2>
                <p>
                  Readings sync from your cuff, are checked against your
                  baseline and your care plan, and appear as a single color
                  status. Orange and Red patterns are reviewed by people. Your
                  clinician can view a clean trend report you choose to share.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      What is a normal blood pressure during pregnancy?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Many clinicians consider readings below 140/90 mm Hg
                        within the expected range, but what is right for you
                        depends on your history. Ask your clinician for your
                        personal targets and when to call.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      What blood pressure is too high when pregnant?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Readings of 140/90 or higher are generally considered
                        elevated in pregnancy, and 160/110 or higher is in the
                        severe range needing urgent evaluation. Follow your
                        clinician&apos;s written plan.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      How often should I check my blood pressure while pregnant?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Your clinician sets the schedule. Common plans are once
                        or twice daily for people at higher risk. Consistency
                        matters more than frequency.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can I check my blood pressure with my Apple Watch or
                      Galaxy Watch?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Not for FutureFamilyAI. Apple Watch does not measure
                        blood pressure and Apple&apos;s hypertension
                        notifications are not intended for pregnancy;
                        Samsung&apos;s watch feature gives cuff-calibrated
                        estimates that FutureFamilyAI does not use. A validated
                        upper-arm cuff is the only blood pressure source.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      What time of day is best to take blood pressure when
                      pregnant?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Choose consistent times, often morning and evening,
                        before caffeine or exercise. Rest for five minutes first
                        and record any symptoms.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does high blood pressure in pregnancy go away after birth?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Often it improves, but it can persist or even appear
                        after delivery. Keep monitoring postpartum as your
                        clinician advises.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/monitoring/gestational-hypertension-symptoms">
                    Gestational Hypertension Symptoms →
                  </Link>
                  <Link to="/monitoring/preeclampsia-warning-signs">
                    Preeclampsia Warning Signs →
                  </Link>
                  <Link to="/monitoring/home-blood-pressure-cuff-pregnancy">
                    Home Blood Pressure Cuffs →
                  </Link>
                  <Link to="/monitoring/blood-pressure-chart-pregnancy-trimester">
                    Blood Pressure Chart by Trimester →
                  </Link>
                  <Link to="/monitoring/when-to-call-doctor-blood-pressure-pregnancy">
                    When to Call Your Doctor About BP →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">
                      Why blood pressure matters so much in pregnancy
                    </a>
                  </li>
                  <li>
                    <a href="#s2">How to take an accurate reading at home</a>
                  </li>
                  <li>
                    <a href="#s3">What your readings mean — and who decides</a>
                  </li>
                  <li>
                    <a href="#s4">How FutureFamilyAI helps</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
